var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 41,
    viewBox: "0 0 58 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.94043V38.2475L20.3894 17.9589L0 1.94043Z",
    fill: "#5EB5AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9423 23.9839C29.6659 24.2011 29.333 24.3102 29.0002 24.3102C28.6674 24.3102 28.3346 24.202 28.0582 23.9839L22.8062 19.8579L2.1626 40.3989H55.8379L35.1942 19.8579L29.9423 23.9839Z",
    fill: "#5EB5AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0002 38.2475V1.94043L37.6108 17.9589L58.0002 38.2475Z",
    fill: "#5EB5AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5307 0H2.46924L28.9999 20.8442L55.5307 0Z",
    fill: "#5EB5AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2fb03d27bdd131153fdd90b018534aaa.svg";
export { ForwardRef as ReactComponent };